module.exports = __webpack_public_path__ + "static/media/design.ce0778e5.png";